var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "pagination" } }, [
    _c("div", { staticClass: "actions" }, [
      _c("a", { on: { click: _vm.decrease } }, [_vm._v("<")]),
      _vm._v(" "),
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.currentPage,
            expression: "currentPage",
          },
        ],
        attrs: {
          max: Math.ceil(_vm.total / _vm.selectedPage),
          min: 1,
          trim: "",
          type: "number",
        },
        domProps: { value: _vm.currentPage },
        on: {
          input: function ($event) {
            if ($event.target.composing) {
              return
            }
            _vm.currentPage = $event.target.value
          },
        },
      }),
      _vm._v(" "),
      _c("div", { attrs: { id: "seperator" } }, [_vm._v("/")]),
      _vm._v(" "),
      _c("span", { staticStyle: { width: "auto", "margin-left": "6px" } }, [
        _vm._v(_vm._s(Math.ceil(_vm.total / _vm.selectedPage))),
      ]),
      _vm._v(" "),
      _c("a", { on: { click: _vm.increase } }, [_vm._v(">")]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "page" }, [
      _c(
        "select",
        {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.selectedPage,
              expression: "selectedPage",
            },
          ],
          on: {
            change: function ($event) {
              var $$selectedVal = Array.prototype.filter
                .call($event.target.options, function (o) {
                  return o.selected
                })
                .map(function (o) {
                  var val = "_value" in o ? o._value : o.value
                  return val
                })
              _vm.selectedPage = $event.target.multiple
                ? $$selectedVal
                : $$selectedVal[0]
            },
          },
        },
        _vm._l(_vm.pageSizes, function (size, i) {
          return _c("option", { key: i, domProps: { value: parseInt(size) } }, [
            _vm._v(
              "\n                " +
                _vm._s(size + _vm.$t("message.perPage")) +
                "\n            "
            ),
          ])
        }),
        0
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }